const GIZMOSPACE_LOCAL = 'local';
const GIZMOSPACE_WORLD = 'world';
const GIZMOAXIS_X = 'x';
const GIZMOAXIS_Y = 'y';
const GIZMOAXIS_Z = 'z';
const GIZMOAXIS_YZ = 'yz';
const GIZMOAXIS_XZ = 'xz';
const GIZMOAXIS_XY = 'xy';
const GIZMOAXIS_XYZ = 'xyz';
const GIZMOAXIS_FACE = 'face';

export { GIZMOAXIS_FACE, GIZMOAXIS_X, GIZMOAXIS_XY, GIZMOAXIS_XYZ, GIZMOAXIS_XZ, GIZMOAXIS_Y, GIZMOAXIS_YZ, GIZMOAXIS_Z, GIZMOSPACE_LOCAL, GIZMOSPACE_WORLD };
